import { useAgwManagerService } from "@/services/AgwManagerService";

export function validators(errors, setError) {
  const agwManagerService = useAgwManagerService();
  return {
    autocomplete: (event, inputOptions) => {
      // language does not matter, here. They must all
      // have the same keys.
      const value = event.target.value;
      const errStr = inputOptions.byKey[value]
        ? "" : "Failed string";
      setError(errors, event, errStr);
    },
    pattern: (event, pattern) => {
      const errStr = (new RegExp(pattern).test(event.target.value))
        ? "" : "Failed pattern";
      setError(errors, event, errStr);
    },
    required: (event) => {
      const errStr = (event.target.value && event.target.value.length > 0)
        ? "" : "Missing property";
      setError(errors, event, errStr);
    },
    backend: async (event, section, urlComponent = 'productfinder') => {
      const path = `/body/${section}/${event.target.name}`
      const data = await agwManagerService.fetchJson(
        `/${urlComponent}/validate-path`,
        {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            path: path,
            value: event.target.value,
          }),
        }
      );
      const errStr = data.errors?.[0].message || "";
      setError(errors, event, errStr);
      return data?.result && data.result === 'ok';
    },
    checked: (event) => {
      const errStr = event.target.value ? "" : "Missing property";
      setError(errors, event, errStr);
    },
    phone: async (event, countryValue) => {
      const data = await agwManagerService.fetchJson(
        `/productfinder/validate-phone?phone=${event.target.value}&country=${countryValue}`,
        {
          method: "GET",
          headers: {
            'Content-Type': 'application/json'
          },
        }
      );
      const errStr = data.errors?.[0].message || "";
      setError(errors, event, errStr);
      return data?.result && data.result === 'ok';
    }
  }
}

